__turbopack_context__.v({
  "marquee": "career-module-scss-module___Yijwq__marquee",
});
